<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="调拨单号">
                <a-input v-model="queryParam.transferNo" placeholder="请输入调拨单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="调出门店名称">
                <a-input v-model="queryParam.fromOrgName" placeholder="请输入调出门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="调入门店名称">
                <a-input v-model="queryParam.toOrgName" placeholder="请输入调入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="调拨状态">
                <a-select v-model="queryParam.transferStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="2">已出库</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                  <a-select-option :value="4">已入库</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:transfer:create']">
          <a-icon type="plus" />创建调拨单
        </a-button>
      </div>

      <create-form ref="createForm" @ok="getList" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="transferStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">{{ parseTime(text) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:transfer:query']"><a-icon type="eye" />详情</a>
          <a-divider type="vertical" v-if="record.transferStatus === 0" />
          <a @click="handleApprove(record)" v-if="record.transferStatus === 0" v-hasPermi="['retail:transfer:approve']"><a-icon type="check" />审核</a>
          <a-divider type="vertical" v-if="showOutStock(record)" />
          <a @click="handleOutStock(record)" v-if="showOutStock(record)" v-hasPermi="['retail:transfer:out']"><a-icon type="export" />出库</a>
          <a-divider type="vertical" v-if="showInStock(record)" />
          <a @click="handleInStock(record)" v-if="showInStock(record)" v-hasPermi="['retail:transfer:in']"><a-icon type="import" />入库</a>
          <a-divider type="vertical" v-if="record.transferStatus < 3" />
          <a @click="handleCancel(record)" v-if="record.transferStatus < 3" style="color: red" v-hasPermi="['retail:transfer:cancel']"><a-icon type="close" />取消</a>
        </span>
      </a-table>
    </a-card>

    <a-modal title="调拨单详情" :visible="detailVisible" :footer="null" @cancel="detailVisible = false" width="1000px">
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="调拨单号">{{ currentDetail.transferNo }}</a-descriptions-item>
        <a-descriptions-item label="调出门店名称">{{ currentDetail.fromOrgName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="调入门店名称">{{ currentDetail.toOrgName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="调拨状态">
          <a-tag :color="getStatusColor(currentDetail.transferStatus)">{{ getStatusText(currentDetail.transferStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="出库时间">{{ parseTime(currentDetail.outTime) }}</a-descriptions-item>
        <a-descriptions-item label="入库时间">{{ parseTime(currentDetail.inTime) }}</a-descriptions-item>
        <a-descriptions-item label="备注">{{ currentDetail.remark || '-' }}</a-descriptions-item>
      </a-descriptions>
      <a-divider>明细</a-divider>
      <a-table rowKey="id" :columns="itemColumns" :data-source="currentDetail?.items || []" :pagination="false" size="small" />
    </a-modal>

    <a-modal title="审核调拨单" :visible="approveVisible" @ok="handleApproveSubmit" @cancel="approveVisible = false">
      <a-form-model :model="approveForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="approveForm.approved">
            <a-radio :value="true">通过</a-radio>
            <a-radio :value="false">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核意见">
          <a-textarea v-model="approveForm.remark" placeholder="请输入审核意见" :rows="4" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="入库" :visible="inStockVisible" @ok="handleInStockSubmit" @cancel="inStockVisible = false" width="800px">
      <a-table rowKey="id" :columns="inStockColumns" :data-source="inStockItems" :pagination="false" size="small">
        <span slot="receivedCount" slot-scope="text, record">
          <a-input-number v-model="record.receivedCount" :min="0" :max="record.transferCount" :precision="0" style="width: 120px" />
        </span>
      </a-table>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import storage from 'store'
import { getTransferOrderList, getTransferOrderDetail, approveTransferOrder, outStockTransferOrder, inStockTransferOrder, cancelTransferOrder } from '@/api/retail/transfer'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'Transfer',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      approveVisible: false,
      inStockVisible: false,
      currentDetail: null,
      approveForm: { transferOrderId: undefined, approved: true, remark: '' },
      inStockItems: [],
      inStockOrderId: null,
      currentShopId: null,
      queryParam: { transferNo: undefined, fromOrgName: undefined, toOrgName: undefined, transferStatus: undefined, current: 1, size: 10 },
      pagination: { total: 0, current: 1, pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: total => `共 ${total} 条` },
      columns: [
        { title: '调拨单号', dataIndex: 'transferNo', width: 180, align: 'center' },
        { title: '调出门店名称', dataIndex: 'fromOrgName', width: 150, align: 'center' },
        { title: '调入门店名称', dataIndex: 'toOrgName', width: 150, align: 'center' },
        { title: '调拨状态', dataIndex: 'transferStatus', width: 100, scopedSlots: { customRender: 'transferStatus' }, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 180, scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 250, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ],
      itemColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 150, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 120, align: 'center' },
        { title: '调拨数量', dataIndex: 'transferCount', width: 100, align: 'center' },
        { title: '入库数量', dataIndex: 'inCount', width: 100, align: 'center' }
      ],
      inStockColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 150, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 120, align: 'center' },
        { title: '调拨数量', dataIndex: 'transferCount', width: 100, align: 'center' },
        { title: '入库数量', dataIndex: 'receivedCount', scopedSlots: { customRender: 'receivedCount' }, width: 150, align: 'center' }
      ]
    }
  },
  created() {
    // 获取当前登录用户的门店ID
    const shopId = this.$store.getters.shopId || storage.get('shopId')
    if (shopId) {
      // 转换为数字类型进行比较
      this.currentShopId = parseInt(shopId)
    }
    this.getList()
  },
  methods: {
    moment,
    customRow(record) {
      return {
        on: {
          click: () => {}
        }
      }
    },
    // 判断是否显示出库按钮
    showOutStock(record) {
      const result = record.transferStatus === 1 && this.currentShopId == record.fromOrgId
      return result
    },
    // 判断是否显示入库按钮
    showInStock(record) {
      const result = record.transferStatus === 2 && this.currentShopId == record.toOrgId
      return result
    },
    parseTime(time) { return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-' },
    getStatusText(status) { const map = { 0: '待审核', 1: '已审核', 2: '已出库', 3: '已取消', 4: '已入库' }; return map[status] || '-' },
    getStatusColor(status) { const map = { 0: 'orange', 1: 'blue', 2: 'cyan', 3: 'red', 4: 'green' }; return map[status] || 'default' },
    getList() {
      this.loading = true
      getTransferOrderList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleTableChange(pagination) {
      this.queryParam.current = pagination.current
      this.queryParam.size = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() { this.queryParam.current = 1; this.getList() },
    resetQuery() { this.queryParam = { transferNo: undefined, fromOrgName: undefined, toOrgName: undefined, transferStatus: undefined, current: 1, size: 10 }; this.getList() },
    handleDetail(record) {
      getTransferOrderDetail({ transferOrderId: record.id }).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) { this.approveForm.transferOrderId = record.id; this.approveForm.approved = true; this.approveForm.remark = ''; this.approveVisible = true },
    handleApproveSubmit() {
      approveTransferOrder(this.approveForm).then(() => {
        this.$message.success('审核成功')
        this.approveVisible = false
        this.getList()
      })
    },
    handleOutStock(record) {
      this.$confirm({
        title: '确认出库',
        onOk: () => { outStockTransferOrder({ transferOrderId: record.id }).then(() => { this.$message.success('出库成功'); this.getList() }) }
      })
    },
    handleInStock(record) {
      getTransferOrderDetail({ transferOrderId: record.id }).then(response => {
        const items = response.data.items || []
        this.inStockItems = items.map(item => {
          return {
            id: item.id,
            goodsId: item.goodsId,
            skuId: item.skuId,
            goodsName: item.goodsName,
            skuName: item.skuName,
            transferCount: item.transferCount,
            receivedCount: item.transferCount
          }
        })
        this.inStockOrderId = record.id
        this.inStockVisible = true
      })
    },
    handleInStockSubmit() {
      const items = this.inStockItems.map(item => ({ goodsId: item.goodsId, skuId: item.skuId, receivedCount: item.receivedCount }))
      inStockTransferOrder({ transferOrderId: this.inStockOrderId, items }).then(() => {
        this.$message.success('入库成功')
        this.inStockVisible = false
        this.getList()
      })
    },
    handleCancel(record) {
      this.$confirm({
        title: '确认取消',
        onOk: () => { cancelTransferOrder({ transferOrderId: record.id, remark: '' }).then(() => { this.$message.success('取消成功'); this.getList() }) }
      })
    }
  }
}
</script>
